import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'URLAUB DE LUXE TUNESIEN',
    description: 'Luxuriöse Ferienvillen mit und ohne Pool, Ferienhäuser und Ferienwohnungen in Zarzis und auf Djerba. Unverbindlich anfragen, persönlich betreut aus Tunesien.',
    placeholder: '',
    url: getOrigin(),
    ogImage: 'https://urlaub-de-luxe-tunesien.cdn.modulify.website/brand/hero-villa.jpg'
}

export const LOCATION_FILTERS = ['Zarzis', 'Djerba']

export const AMENITY_KEYS = [
    'pool',
    'shared_pool',
    'sea_view',
    'beach_access',
    'wifi',
    'ac',
    'heating',
    'kitchen',
    'washing_machine',
    'tv',
    'parking',
    'garden',
    'terrace',
    'rooftop',
    'courtyard',
    'bbq',
    'housekeeping',
    'airport_transfer',
    'baby_cot',
    'elevator'
] as const

export type AmenityKey = typeof AMENITY_KEYS[number]

export const MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=El%20Mouensa%2C%204144%20Zarzis%2C%20Tunisia'
